exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ntable td[data-v-408dfd87], table th[data-v-408dfd87]{\n  border:none;\n  padding-left: 0;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/billing/PurchaseAdditionalReviewsPaymentDetails.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;CACjB","file":"PurchaseAdditionalReviewsPaymentDetails.vue","sourcesContent":["\ntable td[data-v-408dfd87], table th[data-v-408dfd87]{\n  border:none;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-408dfd87","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/billing/PurchaseAdditionalReviewsPaymentDetails.vue
// module id = ER8G
// module chunks = 4